module.exports = __webpack_public_path__ + "static/media/BladeRX_S9_adapter_install.72c611f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/wiper-blades-adapters/BladeRX_S9_adapter_install.jpg
// module id = 830
// module chunks = 0